import { useState, useRef, useEffect, useCallback } from 'react';
import './table/EditorTable.css';

function FolderChips({
    folders,
    currentFolderId,
    onNavigate,
    onCreateFolder,
    onEditFolder,
    onDeleteFolder,
}) {
    const [contextMenu, setContextMenu] = useState(null);
    const [editingFolderId, setEditingFolderId] = useState(null);
    const contextRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (!contextMenu) return;
        const handleClick = (e) => {
            if (contextRef.current && !contextRef.current.contains(e.target)) {
                setContextMenu(null);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [contextMenu]);

    useEffect(() => {
        if (editingFolderId && inputRef.current) {
            inputRef.current.select();
        }
    }, [editingFolderId]);

    const handleCreate = () => {
        const nom = window.prompt('Nom de la nova carpeta:');
        if (nom) onCreateFolder(nom);
    };

    const startEditing = useCallback((folderId) => {
        setContextMenu(null);
        setEditingFolderId(folderId);
    }, []);

    const commitRename = useCallback((folder, newName) => {
        setEditingFolderId(null);
        if (newName && newName.trim() && newName.trim() !== folder.nom) {
            onEditFolder(folder.id, newName.trim());
        }
    }, [onEditFolder]);

    const handleDelete = (folder) => {
        setContextMenu(null);
        const confirmed = window.confirm(`Eliminar la carpeta "${folder.nom}"? Les plantilles es mouran a l'arrel.`);
        if (confirmed) onDeleteFolder(folder.id);
    };

    const sortedFolders = [...(folders || [])].sort((a, b) =>
        (a.sort_order || 0) - (b.sort_order || 0) || a.nom.localeCompare(b.nom)
    );

    return (
        <div className="editor-folder-chips">
            {/* "Totes" chip */}
            <button
                className={`editor-folder-chip${currentFolderId === null ? ' active' : ''}`}
                onClick={() => onNavigate(null)}
            >
                Totes
            </button>

            {sortedFolders.map(folder => (
                editingFolderId === folder.id ? (
                    <span key={folder.id} className={`editor-folder-chip editing${currentFolderId === folder.id ? ' active' : ''}`}>
                        <input
                            ref={inputRef}
                            className="editor-folder-chip-input"
                            defaultValue={folder.nom}
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    commitRename(folder, e.target.value);
                                } else if (e.key === 'Escape') {
                                    setEditingFolderId(null);
                                }
                            }}
                            onBlur={(e) => commitRename(folder, e.target.value)}
                        />
                    </span>
                ) : (
                    <button
                        key={folder.id}
                        className={`editor-folder-chip${currentFolderId === folder.id ? ' active' : ''}`}
                        onClick={() => onNavigate(folder.id)}
                        onDoubleClick={() => startEditing(folder.id)}
                        onContextMenu={(e) => {
                            e.preventDefault();
                            setContextMenu({ id: folder.id, x: e.clientX, y: e.clientY });
                        }}
                    >
                        {folder.nom}
                    </button>
                )
            ))}

            {/* Add folder button */}
            <button
                className="editor-folder-chip-add"
                onClick={handleCreate}
                title="Crea carpeta"
            >
                + Carpeta
            </button>

            {/* Context menu */}
            {contextMenu ? (
                <div
                    ref={contextRef}
                    className="editor-actions-popover"
                    style={{
                        position: 'fixed',
                        left: contextMenu.x,
                        top: contextMenu.y,
                        right: 'auto',
                    }}
                >
                    <button onClick={() => startEditing(contextMenu.id)}>
                        Renombrar
                    </button>
                    <div className="popover-divider" />
                    <button className="danger" onClick={() => handleDelete(sortedFolders.find(f => f.id === contextMenu.id))}>
                        Eliminar carpeta
                    </button>
                </div>
            ) : null}
        </div>
    );
}

export default FolderChips;
